import React from 'react';
import { Lock } from 'lucide-react';
import { usePlan } from '../../hooks/usePlan';
import { useNavigate } from 'react-router-dom';

export const PlanGate = ({ required = 'pro', children, fallback }) => {
  const { canAccess } = usePlan();
  const navigate = useNavigate();

  if (canAccess(required)) return children;

  if (fallback) return fallback;

  return (
    <div className="flex flex-col items-center justify-center py-14 px-6 text-center border border-dashed border-slate-200 rounded-xl bg-slate-50">
      <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center mb-3">
        <Lock className="w-5 h-5 text-amber-600" />
      </div>
      <div className="text-sm font-semibold text-slate-900 mb-1">
        {required === 'pro' ? 'Pro Plan Required' : `${required} Plan Required`}
      </div>
      <p className="text-xs text-slate-500 max-w-xs mb-4">
        This feature is available on the Pro plan. Upgrade to unlock salary advances, WhatsApp payslip delivery, multi-user roles, and more.
      </p>
      <button
        onClick={() => navigate('/settings?tab=billing')}
        className="text-xs font-medium text-[#2E6DA4] hover:underline"
      >
        Upgrade to Pro →
      </button>
    </div>
  );
};